import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const telefoniaRoutes = [
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/LlamadasContestadas')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.llamadas_contestadas.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.reportes.llamadas_contestadas.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/LlamadasFallidas')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.llamadas_fallidas.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.reportes.llamadas_fallidas.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/LlamadasBloqueadas')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.llamadas_bloqueadas.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.reportes.llamadas_bloqueadas.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/ResumenPorFecha')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.resumen_por_fecha.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.reportes.resumen_por_fecha.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/ResumenPrefijos')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.resumen_prefijos.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.reportes.resumen_prefijos.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/ResumenIp')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.resumen_ip.path,
    shouldRender: PATH_DASHBOARD.telefonia.reportes.resumen_ip.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/reportes/InformeBloqueos')),
    ),
    path: PATH_DASHBOARD.telefonia.reportes.informe_bloqueos.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.reportes.informe_bloqueos.renderCondition,
  },
  {
    component: Loadable(lazy(() => import('../pages/telefonia/reportes/Cdr'))),
    path: PATH_DASHBOARD.telefonia.reportes.cdr.path,
    shouldRender: PATH_DASHBOARD.telefonia.reportes.cdr.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/administracion/CsvBloqueos')),
    ),
    path: PATH_DASHBOARD.telefonia.administracion.csv_bloqueos.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.administracion.csv_bloqueos.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/administracion/NumerosBloqueados')),
    ),
    path: PATH_DASHBOARD.telefonia.administracion.numeros_bloqueados.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.administracion.numeros_bloqueados
        .renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/administracion/HistorialBloqueos')),
    ),
    path: PATH_DASHBOARD.telefonia.administracion.historial_bloqueos.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.administracion.historial_bloqueos
        .renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/graficos/MinutosUtilizados')),
    ),
    path: PATH_DASHBOARD.telefonia.graficos.minutos_utilizados.path,
    shouldRender:
      PATH_DASHBOARD.telefonia.graficos.minutos_utilizados.renderCondition,
  },
  {
    component: Loadable(
      lazy(() => import('../pages/telefonia/administracion/Ani')),
    ),
    path: PATH_DASHBOARD.telefonia.administracion.ani.path,
    shouldRender: PATH_DASHBOARD.telefonia.administracion.ani.renderCondition,
  },
];

export default telefoniaRoutes;
